const RoyalIcon = () => (
  <svg
    className="ng-tns-c2-1"
    height="42px"
    version="1.1"
    viewBox="0 0 268 296"
    width="42px"
    xmlns="http://www.w3.org/2000/svg"
    fill="#005edc"
  >
    <g className="ng-tns-c2-1" id="Page-1">
      <g className="ng-tns-c2-1" id="crown-anchor_solo-01">
        <g className="ng-tns-c2-1" id="Group">
          <path
            className="ng-tns-c2-1"
            d="M134.5,0 C148.7,13.8 164.7,28.4 178.5,42.7 L162.4,63.5 L162.4,64.5 L205,83.6 L233.9,63.8 L216.5,44.4 L216.5,43 C234.4,30.3 249.7,18.1 267.1,6.5 L258.7,93.3 L9.3,93.3 L0.9,6.6 C18.3,18.2 33.6,30.4 51.5,43.1 L51.5,44.5 L34.1,63.8 L63,83.6 L105.7,64.5 L105.7,63.5 L89.6,42.8 C103.4,28.6 119.3,13.9 133.6,0.1 L134.5,0 L134.5,0 L134.5,0 Z"
            id="Shape"
          ></path>
          <path
            className="ng-tns-c2-1"
            d="M256.8,108.9 L254.3,137.8 L162,137.8 L162,237.7 L207,237.4 C217,237.4 227.6,226.8 225.4,219.9 C223,209.8 213.9,203.1 205.6,198.1 C207.3,198.1 238.1,175.4 252.5,165.6 C251.8,171.8 241.5,253.5 241.4,254.8 L134.9,295.3 L133.2,295.3 L26.6,255 C26.5,253.7 16.2,172 15.5,165.8 C29.9,175.6 60.8,198.3 62.4,198.3 C54,203.3 45,210 42.6,220.1 C40.5,227 51,237.6 61,237.6 L106,237.9 L106,138 L13.7,138 L11.2,109.1 L256.8,109.1 L256.8,108.9 L256.8,108.9 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default RoyalIcon;
